import { createSlice } from "@reduxjs/toolkit";
import { FeatureList } from "../models/models";

interface projectFeature {
    toggleEdit: boolean;
    isShowCreatorFeature: boolean;
    features: FeatureList;
}

const initialState: projectFeature = {
    toggleEdit: false,
    isShowCreatorFeature: false,
    features: []
}

const projectSlice = createSlice({
    initialState,
    name: "project",
    reducers: {
        toggle(state) {
            state.toggleEdit = !state.toggleEdit
        },

        addFeature(state, action) {
            state.features.push({ name: action.payload, id: 0 })
        },

        creatorNewFeature(state) {
            state.features.push({ name: "FeatureName", id: -1 })
        },

        showCreatorNewFeature(state) {
            state.isShowCreatorFeature = !state.isShowCreatorFeature;
        }
    }
})

export const projectSliceActions = projectSlice.actions;

export default projectSlice;